import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { Observable } from 'rxjs/Observable';
import { Utility } from '../../../common/utility';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
@Injectable()
export class NoteService {
    constructor(public baseService: BaseService) {
    }

    public getConsultationNote(consultationId: string, patientId: string) {
        const url = ConsultationUrl.CONSULTATION_HISTORY_NOTE;
        if (consultationId) {
            return this.baseService.getData(url, { consultationId: consultationId, patientId: patientId });
        }
        return this.baseService.getData(url, { patientId: patientId });
    }
    public saveConsultationNote(consultationId: string, note: string) {
        const url = Utility.stringFormat(ConsultationUrl.CONSULTATION_NOTE, [consultationId]) + '?isFromConsultationHistory=true';
        return this.baseService.postData(url, { note: note });
    }
}


// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/note/note.service.ts